// extracted by mini-css-extract-plugin
module.exports = {"division":"index__division___1E8Oo","vertical":"index__vertical___3zDp5"};